import { Box, Container, Typography, styled } from "@mui/material";
import React, { useEffect } from "react";

import Page from "../components/Page";
import Banner from "../containers/Banner/Banner";
import DirectorsWord from "../containers/DirectorsWord/DirectorsWord";
import WhoWeAre from "../containers/WhoWeAre/WhoWeAre";
import AfriqualeosMean from "../containers/AfriqualeosMean/AfriqualeosMean";
import OurJobs from "../containers/OurJobs/OurJobs";
import { WavyDivider } from "../styles/HomeStyles";
import MySpeedDial from "../components/MySpeedDial";
import Footer from "../containers/Footer/Footer";
import Navbar from "../containers/Navbar/Navbar";
import Africa from "../containers/Africa/Africa";
import ScrollToTop from "../containers/ScrollToTop/ScrollToTop";

const Home = () => {
  return (
    <Page title="Home" sx={{ overflow: " hidden" }}>
      <Navbar />
      {/* <MySpeedDial /> */}

      <Banner />

      <Box id="nous">
        <WhoWeAre />
      </Box>

      <Box id="mot_directeur">
        <DirectorsWord />
      </Box>

      <Africa />

      <Box id="nos_metiers">
        <OurJobs />
      </Box>

      <AfriqualeosMean />
    </Page>
  );
};

export default Home;
